// Usage:
//   import { zIndex } from '...'
//
//   const style = {
//     ...zIndex.Z_INDEX1
//   }
export default {
  Z_INDEX0: {
    zIndex: 0
  },
  Z_INDEX1: {
    zIndex: 100
  },
  Z_INDEX2: {
    zIndex: 200
  },
  Z_INDEX3: {
    zIndex: 300
  },
  Z_INDEX4: {
    zIndex: 400
  },
  Z_INDEX5: {
    zIndex: 500
  },
  Z_INDEX6: {
    zIndex: 600
  },
  Z_INDEX7: {
    zIndex: 700
  },
  Z_INDEX8: {
    zIndex: 800
  },
  Z_INDEX9: {
    zIndex: 900
  }
};